import React from 'react';
import './CoreBusiness.css';

// Import the new image
import businessImage from '../../assets/images/core-business.jpg';

const CoreBusiness = () => {
  return (
    <section className="core-business-section">
      <div className="core-business-container">
        {/* Left Column: Text Content */}
        <div className="core-business-text-col">
          <h2>Grow the core business</h2>
          <p>
            We start by establishing a clear picture of your current market position grounded in data, not assumptions. From there, we map out multiple growth scenarios, giving you strategic flexibility.
          </p>
          <p>
            Finally, we build modular and scalable operational and marketing plans designed to strengthen your core business and support long-term growth.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="core-business-image-col">
          <img src={businessImage} alt="Professionals discussing business growth" />
        </div>
      </div>
    </section>
  );
};

export default CoreBusiness;